<template>
    <Layout>
        <input type="text" value="" id="clipElement" >
        <section class="section" style="padding-bottom:8px" v-show="pageIsDisable == false">
            <div class="container">

                <!-- <table class="non-printable" style="margin-top: 15px;">
                    <tbody><tr>

                        <td style="width: 40px; text-align: center;">
                            <a v-if="!data.client.isPresenter && data.loaded " @click="download()">
                                <img src="@/assets/img/pdf_download.png" id="ctl00_PlaceHolderMain_GoogleImg">
                            </a>
                        </td>
                        <td v-if="!data.client.isPresenter && data.loaded " style="width: 40px; text-align: center;">
                            <a @click="sendToMail()">
                                <img src="@/assets/img/sendMail.png" id="ctl00_PlaceHolderMain_GoogleImg">
                            </a>
                        </td>

                        <td style="width: 95px;">
                            <a href="https://play.google.com/store/apps/details?id=com.project.efg.ems" target="_blank">
                                <img src="@/assets/img/googleplay.png" id="ctl00_PlaceHolderMain_GoogleImg">
                            </a>
                        </td>
                        <td>
                            <a href="https://itunes.apple.com/eg/app/efg-hermes-conferences/id1029064078?mt=8 " target="_blank">
                                <img src="@/assets/img/appstore.png" id="ctl00_PlaceHolderMain_AppleImg" style="margin-left: 8px">
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="4" align="right"></td>
                    </tr>
                </tbody></table> -->

                <div class="printable mob-view-container" id="pdf" >
                    <div style="margin-top: 20px; text-align: left;">
                        <img id="ctl00_PlaceHolderMain_efgLogo" class="efg-logo" :src="`${baseUrl}/assets/img/logo.svg`">
                    </div>
                    <div style="width: 85%"></div>
                        <!-- <ul class="text-center">
                            <li style="text-align: center; width: 100%; font-family: Calibri; font-size: 18px">The 8th Annual London Conference</li>
                            <li style="text-align: center; width: 100%; font-family: Calibri; font-size: 18px">10-13 September 2018</li>
                            <li style="text-align: center; width: 100%; font-family: Calibri; font-size: 18px">Emirates Arsenal Stadium, N5 1BU</li>
                            <li style="text-align: center; width: 100%; font-family: Calibri; font-size: 18px">South entrance – Dial Square Suite</li>
                        </ul> -->
                        <div class="text-center" style="white-space:pre-wrap;margin-bottom:1.5rem">{{data.title}}</div>

                        <template v-if="!data.client.isPresenter && data.loaded">
                            <div style="margin-bottom:1.5rem;display:flex;flex-direction:column;justify-content:center;align-items:center" >
                                <label ><b style="color:red" >Please select your time zone/city so your schedule appears accordingly. </b> </label>
                                <div class="timezone-wrapper"  >
                                    <span style="margin-right:4px" ><strong>Time zone:</strong></span>
                                    <VueSelect
                                        class="w-80"
                                        :options="data.timeZones"
                                        @input="changeTimeZone"
                                        :value="data.selected_timeZone.label"
                                        placeholder="Select Time Zone"
                                        >
                                    </VueSelect>
                                </div>
                            </div>
                        </template>

                        <!-- <template v-if="data.client.isPresenter">
                            <div style="margin-bottom:1.5rem;display:flex;flex-direction:column;justify-content:center;align-items:center" >
                                <label ><b style="color:red" >Please select your time zone/city so your schedule appears accordingly. </b> </label>
                                <div class="timezone-wrapper"  >
                                    <span style="margin-right:4px" ><strong>Time zone:</strong></span>
                                    <VueSelect
                                        class="w-80"
                                        :options="data.timeZones"
                                        @input="changeTimeZone"
                                        :value="data.selected_timeZone.label"
                                        placeholder="Select Time Zone"
                                        >
                                    </VueSelect>
                                </div>
                            </div>
                        </template> -->

                        <div style="display:flex;justify-content:center;margin-bottom:1rem" >
                            <p style="margin:10px 6px 0px 0px" ><strong>Useful Resources:</strong></p>
                            <ul id="usefulResourceList" >
                                <li v-if="!data.client.isPresenter" style="margin-right:6px"> <a href="/auth/companies" target="_blank"> <img src="../../assets/presentation.png" alt="..."> </a> </li>
                                <li v-if="!data.client.isPresenter" >
                                    <a style="cursor:pointer" href="https://files.efghermes.com/UserFiles/Conferences/89/downloads/Company_list.xlsx"> <img src="../../assets/company.jpg" alt="..."> </a>
                                </li>
                                <li v-if="!data.client.isPresenter" > <a href="https://files.efghermes.com/UserFiles/Conferences/89/downloads/The_EFG_Hermes_and_Tadawul_Investor_Conference.pdf" target="_blank"> <img src="../../assets/researchbooklet.jpg" alt="..."> </a> </li>
                                <li>
                                    <a v-if="!data.client.isPresenter" href="https://2ndvirtualconference.efghermes.com/UserFiles/Conferences/87/Downloads/joining-webex-meetings-for-investors.pdf" target="_blank"> <img src="../../assets/webexguide.jpg" alt="..."> </a> </li>
                                    <a v-if="data.client.isPresenter" href="https://2ndvirtualconference.efghermes.com/UserFiles/Conferences/87/Downloads/joining-webex-meetings-for-companies.pdf" target="_blank"> <img src="../../assets/webexguide.jpg" alt="..."> </a> </li>
                                <li> <a href="mailto:schedules@efg-hermes.com?subject=Schedule%20Assistance%20-%20The%20EFG%20Hermes%20and%20Tadawul%20Investor%20Conference"> <img src="../../assets/contact.jpg" alt="..."> </a> </li>

                                <li v-if="data.client.isPresenter" > <a href="mailto:IT_Assist-Conference@EFG-HERMES.com?cc=schedules@efg-hermes.com&subject=IT%20Assistance%20-%20The%20EFG%20Hermes%20and%20Tadawul%20Investor%20Conference%20(Presenter)&body=Please%20provide%20any%20of%20the%20following:%0D%0D%20%20%20-%20Webex%20room%20link:%0D%20%20%20-%20Meeting%20ID%20and%20Password:%0D%20%20%20-%20Contact%20Number:"> <img src="../../assets/IT.jpg" alt="..."> </a> </li>
                                <li v-if="!data.client.isPresenter" > <a href="mailto:IT_Assist-Conference@EFG-HERMES.com?cc=schedules@efg-hermes.com&subject=IT%20Assistance%20-%20The%20EFG%20Hermes%20and%20Tadawul%20Investor%20Conference%20(Investor)&body=Please%20provide%20any%20of%20the%20following:%0D%0D%20%20%20-%20Webex%20room%20link:%0D%20%20%20-%20Meeting%20ID%20and%20Password:%0D%20%20%20-%20Contact%20Number:"> <img src="../../assets/IT.jpg" alt="..."> </a> </li>
                            </ul>
                        </div>

                        <table>
                            <tr>
                                <td style="width: 200px;"><span style="color:#00502E;font-weight:bold;">Company :</span></td>
                                <td style="width: auto;">{{ data.client.company_name }}</td>
                            </tr>
                            <tr>
                                <td style="width: 200px;"><span style="color:#00502E;font-weight:bold;">Representative :</span></td>
                                <template v-if="data.client.isPresenter">
                                    <td style="width: auto;" v-if="data.client.company">
                                        <div v-for="client in data.client.company.clients" :key="client.id + '' + data.client.company.id">
                                            {{ client.full_titled_name }}; {{ client.job_title }}
                                        </div>
                                    </td>
                                </template>
                                <template v-else>
                                    <td>
                                        {{ data.client.name }}; {{ data.client.job_title }}
                                    </td>
                                </template>
                            </tr>
                             <tr  v-if="!data.conf.is_virtual && data.client.isPresenter">
                                <td style="width: 200px;"><span style="color:#00502E;font-weight:bold;">RoomNo :</span></td>
                                <td style="width: auto;">{{ data.room_number }}</td>
                            </tr>
                        </table>
                        <hr>

                        <div v-for="(slots, date) in data.schedule" style="margin-bottom:8px" :key="date">

                            <template v-if="data.client.isPresenter">
                                <span v-if="data.selected_timeZone && data.selected_timeZone.label" style="color:#00502E;font-weight:bold;">{{ dataFormat(date , "DD MMMM Y" ) }}</span>
                            </template>
                            <template v-else>
                                <span style="color:#00502E;font-weight:bold;">{{ dataFormat(date , "DD MMMM Y" ) }}</span>
                            </template>
                            <table v-if="!data.client.isPresenter" width="100%" id="dataTable" class="tableHead wid-on-mob" style="border-spacing: 0px;" >
                                <thead>
                                    <tr>
                                        <th style="width:15%"><b>Time</b></th>
                                        <th style="width:15%"><b>Presenting Company</b></th>
                                        <th style="width:30%"><b>Webex Room Details</b></th>
                                        <th style="width:45%"><b>Representative(s)</b></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="slot in slots" :key="slot.id">
                                        <td style="width:15%">
                                            <span style="display:flex ; margin-top:4px;display:block" > <img style="margin-right:4px;width:15px;height:15px;margin-top:3px" src="../../assets/clock.jpg" alt=""> {{ slot.start_time }} - {{ slot.end_time }}</span>
                                            <span v-if="data.selected_timeZone && data.selected_timeZone.label" style="display:flex ; margin:auto;" > Time Zone: {{data.selected_timeZone.label}} </span>
                                        </td>

                                        <td v-if="slot.type != 1" style="vertical-align:top;text-align:center;width:15%" >
                                            <div>
                                                 <img class="company_image" :src="(`../../companies/${slot.company.name}.jpg`) "  alt="">
                                            </div>
                                        </td>

                                        <td v-if="slot.type != 1">
                                            <ul>
                                                <li style="margin-bottom: 0px">
                                                    <b> {{ slot.company ? slot.company.name : 'No Company Exist' }}</b>
                                                </li>
                                                <li style="margin-bottom: 0px;font-weight:lighter">{{ slot.name[slot.name.length-1]==='s' ? slot.name.substr(0,slot.name.length-1) : slot.name }} </li>
                                                <li style="margin-bottom: 0px">
                                                    <span v-if="!data.conf.is_virtual">
                                                        RoomNo : {{ slot.room_number }}
                                                    </span>
                                                    <span v-else>
                                                        <span style="display: block;" v-if="slot.room && slot.room.meeting_link">
                                                            <div> Webex Room: <a class="link_click" target="_blank" :href="slot.room.meeting_link">CLICK HERE</a> </div>
                                                            <div style="padding-left:10px" > Meeting ID: <span style="font-weight:lighter" > {{ slot.room.meeting_id }} </span> </div>
                                                            <div style="padding-left:10px" > Password: <span style="font-weight:lighter" > {{ slot.room.meeting_password }} </span> </div>
                                                            <!-- <div style="padding-left:10px" > Join by video system: <span style="font-weight:lighter"> {{ slot.room.sip }} </span> </div> -->
                                                            <!-- <div> SIP: {{ slot.room.sip }} </div> -->
                                                        </span>
                                                    </span>
                                                </li>
                                            </ul>
                                        </td>

                                        <td v-if="slot.type != 1">
                                            <ul>
                                                <li style="font-weight:lighter"  v-for="presenter in slot.presenters"> <img style="margin-right:4px;width:15px;margin-top:3px" src="../../assets/person.png" alt=""> {{ presenter.full_titled_name }}; {{ presenter.job_title }}</li>
                                            </ul>
                                        </td>

                                        <td v-if="slot.type == 1" colspan="3">
                                           <p v-html="slot.description"></p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <table v-if="data.client.isPresenter && data.selected_timeZone && data.selected_timeZone.label" width="100%" id="dataTable" class="tableHead wid-on-mob" style="border-spacing: 0px;">
                                <thead>
                                    <tr>
                                        <th style="width:15%"><b>Time</b></th>
                                        <th style="width:25%"><b>Meeting Details</b></th>
                                        <th style="width:30.1%"><b> Investors </b></th>
                                        <th style="width:40%"><b>Representative</b></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="slot in slots" :key="slot.id">
                                        <td style="width:15%">
                                            <span style="display:flex ; margin-top:4px;" > <img style="margin-right:4px;width:15px;height:15px;margin-top:3px" src="../../assets/clock.jpg" alt=""> {{ slot.start_time }} - {{ slot.end_time }}</span>
                                            <span v-if="data.selected_timeZone && data.selected_timeZone.label" style="display:flex ; margin:auto; " > Time Zone: {{data.selected_timeZone.label}} </span>
                                        </td>
                                        <td v-if="slot.type != 1" >
                                            <div style="font-weight:lighter" > {{ slot.name[slot.name.length-1]==='s' ? slot.name.substr(0,slot.name.length-1) : slot.name }}  </div>
                                            <div v-if="data.conf.is_virtual">
                                                <span style="display: block;" v-if="slot.room && slot.room.meeting_link">
                                                    <div> Webex Meeting Room: <a class="link_click" target="_blank" :href="slot.room.meeting_link">CLICK HERE</a> </div>
                                                    <div style="padding-left:10px" > Meeting ID: <span style="font-weight:lighter">{{ slot.room.meeting_id }} </span> </div>
                                                    <div style="padding-left:10px" > Password: <span style="font-weight:lighter">{{ slot.room.meeting_password }} </span> </div>
                                                    <template v-if="slot.name == 'Big Group Meetings' " >
                                                        <div style="padding-left:10px" > Join by video system: <span style="font-weight:lighter"> {{ slot.room.sip }} </span> </div>
                                                        <div style="padding-left:10px"> Video System Password: <span style="font-weight:lighter"> {{ slot.room.host_key }} </span> </div>
                                                    </template>
                                                    <template v-else >
                                                        <div style="padding-left:10px"> Host Key: <span style="font-weight:lighter"> {{ slot.room.host_key }} </span> </div>
                                                        <div style="padding-left:10px" > Join by video system: <span style="font-weight:lighter"> {{ slot.room.sip }} </span> </div>
                                                    </template>
                                                </span>
                                            </div>
                                        </td>
                                        <td  colspan="2"  v-if="slot.type != 1 ">
                                            <table style="width: 100%;" cellpadding="0" cellspacing="0">
                                                <tr v-for="(clients, company , index) in slot.meetings" style="margin-bottom:20px">
                                                    <td style="width:50%;font-weight:lighter">{{index+1}}- {{ company }}</td>
                                                    <td style="width:50%; border-left:1px solid #555" >
                                                        <table>
                                                            <tr  v-for="(meetingClient , index) in clients">
                                                                <td>
                                                                    <div class="popup-wapper">
                                                                        <span style='cursor:pointer;font-weight:lighter'>
                                                                           <img style="margin-right:4px;width:15px;margin-top:3px" src="../../assets/person.png" alt="">  {{ meetingClient.client.full_titled_name }}; {{ meetingClient.client.job_title }}
                                                                        </span>
                                                                        <div class="popup-body" :id="'client'+meetingClient.client.id" >
                                                                            <span style="font-weight:lighter" > <strong>Email address:</strong> {{ meetingClient.client.email }} </span>
                                                                            <span style="font-weight:lighter" > <strong>Tel:</strong> {{ meetingClient.client.telephone }} </span>
                                                                            <span style="font-weight:lighter" >  <strong>Biography:</strong> {{ meetingClient.client.biography }}  </span>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                </tr>
                                                <!-- <tr v-if="(!data.conf.is_virtual) && (slot.room_number != '' && slot.room_number != data.room_number)">
                                                    <td  style=" border-right:1px solid #555">RoomNo : {{ slot.room_number }}</td>
                                                </tr>
                                                <tr v-if="data.conf.is_virtual">
                                                    <td  style="border-right:1px solid #555">
                                                        <span style="display: block; padding: 10px" v-if="slot.room && slot.room.meeting_link">
                                                            <div> Webex Room: <a class="link_click" :href="slot.room.meeting_link">CLICK HERE</a> </div>
                                                            <div> Meeting ID: <span style="font-weight:lighter">{{ slot.room.meeting_id }} </span> </div>
                                                            <div> Password: <span style="font-weight:lighter"> {{ slot.room.meeting_password }} </span> </div>
                                                            <div> SIP: {{ slot.room.sip }} </div>
                                                            <div> Host Key: {{ slot.room.host_key }} </div>
                                                        </span>
                                                    </td>
                                                </tr> -->
                                            </table>
                                        </td>

                                        <td style="width:80%" v-if="slot.type == 1" colspan="3">
                                           <!-- <span>Subject : {{ slot.name }}</span> -->
                                           <p v-html="slot.description"></p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section style="margin-bottom:8px" >
            <div class="container" style="font-size:.8em">
                <div style="display:flex;justify-content:space-between;padding:0px 1rem" >
                    <span>{{data.client.formatted_name}} Agenda</span>
                    <span>{{pageOpenDate}}</span>
                </div>
                <span style="padding:0px 1rem">Provisional Agenda subject to change</span>
            </div>
        </section>

        <section class="section" v-show="error_message != ''">
            <div class="container">
                <div class="alert alert-danger">
                    {{ error_message }}
                </div>
            </div>
        </section>

        <section id="datatableSection" >
            <table id="presentationDT">
                <thead>
                    <tr v-if="presenting_companies">
                        <th>Company</th>
                        <th>Country</th>
                        <th>Sector</th>
                        <th>Presentations</th>
                        <th>Research Report</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(company,index) in presenting_companies" v-bind:key="index">
                        <td>{{ company.name }}</td>
                        <td>{{ company.country.name}}</td>
                        <td>{{ company.sector.name}}</td>
                        <td>
                            <span
                                v-if="company.uploads.length > 0 && company.uploads[0].presentation"
                                v-on:click="downloadFile(company.id , 'presentation' )"
                            >Download Presentation</span>
                        </td>
                        <td>
                            <span
                                class="_put-cursor"
                                v-if="company.uploads.length > 0 &&company.uploads[0].profile"
                                v-on:click="downloadFile(company.id , 'profile' )"
                            >Download Profile</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </section>


    </Layout>
</template>

<script>
import Vue from 'vue'
import collect from 'collect.js'
var _ = require('lodash');
import Api from '@/Api'
import Layout from '@/components/layouts/Layout.vue'
import * as jsPDF from 'jspdf'
import html2canvas from 'html2canvas';

import { mapState } from 'vuex';
import VueSelect from 'vue-select';

var moment = require('moment');
var momentTZ = require('moment-timezone');

import $ from "jquery";

import JSZip from "jszip";
window.JSZip = JSZip; // required to make Buttons extension work for Excel button

import "datatables.net";
import "datatables.net-dt/css/jquery.dataTables.css";
import "datatables.net-buttons/js/dataTables.buttons";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons-dt/css/buttons.dataTables.min.css";
import "datatables.net-se";
import "datatables.net-buttons-se";

export default {
    name: 'SchedulePreview',
    components: {Layout , VueSelect},
    data() {
        return {
            baseUrl: window.location.origin,
            pageIsDisable: false,
            error_message: '',
            data: {
                conf: {},
                schedule: [],
                client: {
                    isPresenter: false,
                    name: '',
                    company_name: '',
                    job_title : '',
                    formatted_name: ''
                },
                title:null,
                room_number: null,
                loaded:false,
                timeZones: [],
                selected_timeZone : { lable: 'Asia/Saudi Arabia (GMT+03:00)' , code : 'Asia/Saudi Arabia'},
            },
            presenting_companies : [],
            client: JSON.parse(localStorage.getItem('client')).client,
            pageOpenDate: `${moment().format('l')} ${moment().format('LTS')}`
        };
    },
    methods: {
        getPageData() {
            let auth = this.client;
            /*if (auth.client_type.type != 1) {
                this.pageIsDisable = true;
                this.error_message = "You dont have access to this page.";
                return;
            }*/

            Api().get('auth/get-schedule').then((response) => {
                let data = response.data;
                this.data.client.company = data.company;
                this.data.client.isPresenter = data.isPresenter;
                this.data.title = data.title;
                this.data.conf = data.conf;
                const confClient = data.conference_client;
                // this.data.selected_timeZone = (confClient && confClient.timezone ) ? {label: confClient.timezone + " (GMT"+momentTZ.tz(confClient.timezone).format('Z')+")", code: confClient.timezone} : {label: '',code: ''};
                if (data.isPresenter) {
                    this.data.room_number = data.room_number;
                    this.data.schedule = this.scheduleFormatter(data.schedule)
                }else {
                    this.data.schedule = data.schedule;
                }
                if (this.data.schedule.length == 0) {
                    this.pageIsDisable = true;
                    this.error_message = "Schedule not prepared yet.";
                }
                this.changeTimeZone((confClient && confClient.timezone ) ? {label: confClient.timezone + " (GMT"+momentTZ.tz(confClient.timezone).format('Z')+")", code: confClient.timezone} : {label: this.data.selected_timeZone.lable ,code: this.data.selected_timeZone.code })
                this.data.loaded = true;
            })
            .catch((error) => {
                this.data.loaded = true;
                if (error) {
                    if (error.response.status == 422) {
                        this.pageIsDisable = true;
                        var err = error.response.data;
                        this.errors = err.errors;
                    }
                    else if (error.response.status == 401) {
                        this.$store.dispatch("logout");
                        this.$router.push({ name: 'login', query: { redirect: this.$router.currentRoute.fullPath } })
                        //   this.$router.push('login')

                        // setTimeout(e => this.getPageData(), 5000)
                    }
                }
            });
        },
        initClientData(){
            let client = JSON.parse(localStorage.getItem("client")).client;
            this.data.client.name = client.full_titled_name;
            this.data.client.job_title = client.job_title;
            this.data.client.formatted_name = client.formatted_name;
            this.data.client.company_name = client.company ? client.company.name : 'No Company Exist';
        },
        download() {
            let client = JSON.parse(localStorage.getItem("client")).client;
            let conferenceId = process.env.VUE_APP_CONFERENCE_ID;
            if(!client) {
                return;
            }
            window.location = process.env.VUE_APP_API_URL + `/files/auth/download-schedule?conference_id=${conferenceId}&client_id=${client.id}`;
        },

        async convertPageToPDF(){
            var vm = this;
            var html = $('#pdf');
            html.css('padding-left',100)
            html.css('padding-right',200)

            html2canvas(html[0]).then(function(canvas) {
                canvas.toBlob(function(blob){
                    var urlCreator = window.URL || window.webkitURL;
                    var imageUrl = urlCreator.createObjectURL(blob);
                    var img = new Image();
                    img.src = imageUrl;

                    img.onload = function(){
                        console.log('img.width', img.width)
                        console.log('window.outerWidth', window.outerWidth);
                        var pdf = new jsPDF('p','px',[img.height, img.width]);
                        pdf.addImage(img, 'SVG', 0, 0, img.width, img.height);
                        pdf.save(`${vm.data.client.name}.pdf`);
                    };
                })
            });
        },
        sendToMail() {
            var vm = this;
            //send-schedule
            Api().post('auth/send-schedule').then((response) => {
                alert(response.data.message);
            })
            .catch((error) => {
                alert("An error has been occured.");
            });
        },
        scheduleFormatter(schedules) {
            var newScheduleFormat = [] ;
            for (var date in schedules) {
                let slots = schedules[date];
                let newSlots = slots.map( (slot) => {
                    slot.meetings = _.groupBy(slot.meetings, (meeting) => meeting.client.company.name);
                })
            }
            return schedules;
        },
        changeTimeZone({ code, label })
        {
            Object.keys(this.data.schedule).forEach( date =>{
                this.data.schedule[date] = this.data.schedule[date].map( slot => {
                    const startTime = slot.start_time.replace(/\(.+\)/, '');
                    const end_time = slot.end_time.replace(/\(.+\)/, '');
                    slot.start_time = this.convertTimeZone(`${slot.date} ${startTime}`, this.data.selected_timeZone.code || 'Europe/London', code);
                    slot.end_time = this.convertTimeZone(`${slot.date} ${end_time}`, this.data.selected_timeZone.code || 'Europe/London', code);
                    return slot;
                });
            });
            this.data.selected_timeZone.code = code ;
            this.data.selected_timeZone.label = label;
        },
        copyPopupData(client)
        {
            let element = document.getElementById("clipElement");
            let obj = {
                emailaddres: client.email,
                telephone: client.telephone || "" ,
                biography: client.biography || ""
            };

            element.value = `Email address:${client.email},Tel:${client.telephone ? client.telephone : ""},Biography:${client.biography? client.biography : "" }`;
            element.select();
            document.execCommand("Copy");
        },
        convertTimeZone(date, oldTimeZone, newTimeZone) {
            const time = momentTZ.tz(date, oldTimeZone);
            const oldTime = time.format('L');
            time.tz('Europe/London');
            const londonTime = time.format('L');
            time.tz(newTimeZone);
            const newTime = time.format('L');
            const diff = moment(newTime).diff(moment(londonTime), 'days');
            let res = time.format("HH:mm");
            if(diff) {
                res += '(' + (diff > 0 ? '+' : '') + diff + ')';
            }
            return res;
        },
        dataFormat(data,format)
        {
            return moment(data).format(format);
        }
    },
    mounted(){
        // -- check if this page is valid
        //1- init data from api
        this.getPageData();
        this.initClientData();
        this.data.timeZones = this.$store.state.timeZones;

        // const regClient = JSON.parse( localStorage.getItem("registeration.client") );
        // let registered_client_timezone = null;
        // if(regClient) {
        //     registered_client_timezone = regClient.timezone;
        // }
        // this.data.selected_timeZone = registered_client_timezone ? { label : registered_client_timezone + " (GMT"+momentTZ.tz(registered_client_timezone).format('Z')+")" , code : registered_client_timezone  } : {label: '',code: ''} ;
        //2- set avability of this page
    }
};
</script>

<style type="text/css" scopped>
    .tableHead > thead > tr {
        width: 100%; page-break-inside: avoid; page-break-before: auto
    }
    .tableHead > thead > tr > th {
        border: 1px solid gray;
        padding-left: 1%;
        background-color: #00502e;
        height: 40px;
        color: #fff;
        width: 20%;
        vertical-align: middle;
        font-size: 12pt;
        font-weight: bold;
        font-family: Calibri;
    }

    .tableHead > tbody > tr {
        width: 100%; color: black; page-break-inside: avoid; page-break-before: auto
    }
    .tableHead > tbody > tr > td {
        border: 1px solid gray;
        font-weight: bold;
        vertical-align: top;
        padding-left: 1%;
        padding-right: 1%;
        width: 20%;
        font-family: Calibri;
        font-size: 14px;
    }

    .tableHead > tbody > tr > td > table tr td:nth-child(2) {
        padding-left: 1%
    }

    .tableHead > tbody > tr > td > span {
        display:inline-block;
        width:98%;
    }




    .tableHead > tbody > tr:nth(1) {
        border: 1px solid gray; font-weight: bold; vertical-align: top; padding-left: 1%; width: 20%; font-family: Calibri; font-size: 14px
    }

    .company_image{
        max-width: 130px;
        max-height: 100px;
        object-fit: contain;
        border-radius: 2px;
        margin-top: 10px;
    }

    #usefulResourceList {
        display: inline-block;
    }

    #usefulResourceList li {
        white-space:nowrap;
        display: inline;
    }

    #usefulResourceList {
        display: inline-block;
    }

    #usefulResourceList li {
        white-space:nowrap;
        display: inline;
    }

    #datatableSection {
        display:none;
    }
    .popup-wapper {
        position: relative;
    }

    .popup-body {
        position:absolute;
        width: 300px;
        z-index: 1;
        background-color: white;
        padding: 0px 4px;
        display: none;
        box-shadow: 5px 4px 20px #00000029;
        border-radius: 4px;
        border: 1px solid #ccc;
        cursor: unset;
    }
    .popup-body span{ display: block; }

    .popup-wapper:hover .popup-body{
        display: block;
    }

    #clipElement {
        position: absolute;
        top: -9999px;
        left: -9999px;
    }

    .w-80{width: 50%;min-width:300px;}
    .timezone-wrapper{
        width: 75%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .link_click {
        color: blue;
        text-decoration: underline;
    }


    @media(max-width:500px) {
        .mob-view-container {
            overflow: auto;
        }

        .wid-on-mob {
            width: 700px;
        }
        .tableHead > tbody > tr > td {
            font-size: 0.7rem;
        }
        .tableHead > thead > tr > th {
            font-size: 0.7rem;
        }
    }



html{
    background: #fff !important;
}
#pdf {
    margin:15px;
}
</style>
